import { render, staticRenderFns } from "./the-sidebar.vue?vue&type=template&id=2fbaf449"
import script from "./the-sidebar.vue?vue&type=script&lang=js"
export * from "./the-sidebar.vue?vue&type=script&lang=js"
import style0 from "./the-sidebar.vue?vue&type=style&index=0&id=2fbaf449&prod&lang=css"


/* normalize component */
import normalizer from "!../../../CrossD.Portal.Vue/ClientApp/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports